module.exports = __webpack_public_path__ + "static/mischief-mountain-31ec3064b960927b9d480e73cded9ea7.png";